<template>
  <div class="grid gap-[--gap]" :style="{ '--gap': `${lineHeight / 2}px` }">
    <app-skeleton-text
      v-for="i in lines"
      :key="i"
      :width="`${randomLineWidthInPercent()}%`"
    />
  </div>
</template>

<script lang="ts" setup>
const MIN_LINE_WIDTH_IN_PERCENT = 30;

withDefaults(
  defineProps<{
    lines?: number;
    lineHeight?: number;
  }>(),
  { lines: 10, lineHeight: 16 },
);

function randomLineWidthInPercent() {
  return (
    Math.floor(Math.random() * (100 - MIN_LINE_WIDTH_IN_PERCENT)) +
    MIN_LINE_WIDTH_IN_PERCENT
  );
}
</script>
